var map = {
	"./C++.png": "ce93",
	"./HTML 5.png": "38f4",
	"./JS.png": "fe2d",
	"./PostgreSQL.png": "8ad4",
	"./Python.png": "f062",
	"./R.png": "235b",
	"./Vue.js.png": "e4a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc58";